import axios from 'axios';
import qs from 'qs';
import baseURL from './api_url/baseURL.js';
import router from '../router/index.js'
import { Toast } from 'vant';
//设置默认请求路径
axios.defaults.baseURL = baseURL.http;
// axios.defaults.baseURL = 'https://api.weixin.qq.com/';
//设置默认请求头
// axios.defaults.headers.post['Content-Type'] = 'application/json;';// charset=utf-8
axios.defaults.headers = {
	"Content-Type": "application/x-www-form-urlencoded",
};
// 跨域
// axios.defaults.crossDomain = true;
// axios.defaults.withCredentials = true; //设置cross跨域 并设置访问权限 允许跨域携带cookie信息

// axios 拦截器
// 请求
axios.interceptors.request.use(config => {
	console.log("axios",baseURL.http)
	// 请求参数转换为字符串
	if (config.data && config.headers['Content-Type'] == 'application/x-www-form-urlencoded') {
		config.data = qs.stringify(config.data);
	}
	// // 携带token
	// var token = localStorage.getItem("token");
	// if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
	// 	config.headers.authorization = token //请求头加上token
	// }
	return config;
}, error => {
	// toast 模态框异常提示
	// Toast({message: err});
	return Promise.reject(error);
});
// 响应
axios.interceptors.response.use(res => {
	// if (res.data.code || res.data.status) {
		
		//这里面写所需要的代码
		// switch (res.data.code) {
		// 	// 401: 未登录
		// 	// 未登录则跳转登录页面，并携带当前页面的路径
		// 	// 在登录成功后返回当前页面，这一步需要在登录页操作。
		// 	case 401:
		// 		localStorage.removeItem('token');
		// 	    localStorage.setItem('beforeLoginUrl', router.currentRoute.fullPath);
		// 	    router.replace({
		// 	        path: '/login',
		// 	        query: { redirect: router.currentRoute.fullPath }//从定向到登录
		// 	    });
		// 	    break;
		// 	    // 403 token过期
		// 	    // 登录过期对用户进行提示
		// 	    // 清除本地token和清空vuex中token对象
		// 	    // 跳转登录页面
		// 	case 403:
		// 	    // 清除token
		// 	    localStorage.removeItem('token');
		// 	    localStorage.setItem('beforeLoginUrl', router.currentRoute.fullPath);
		// 	    // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
		// 	    // setTimeout(() => {
		// 	    //     router.replace({
		// 	    //         path: '/login',
		// 	    //         query: {
		// 	    //             redirect: router.currentRoute.fullPath
		// 	    //         }
		// 	    //     });
		// 	    // }, 1000);
		// 	    break;
		// 	    // 404请求不存在
		// 	case 404:
		// 	    Toast({
		// 	        message: '网络请求不存在',
		// 	        duration: 1000,
		// 	        forbidClick: true
		// 	    });
		// 	    break;
		// 	    // 其他错误，直接抛出错误提示
		// 	default:
		// 	    Toast({
		// 	        message: error.response.data.message,
		// 	        duration: 1500,
		// 	        forbidClick: true
		// 	    });
		// }
	// }
	return Promise.resolve(res);
}, error => {
	Toast({
		message: "当前网络异常，请稍后再试！",
		duration: 1500,
		forbidClick: true
	});
	return Promise.reject(error);
});

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export const get = (url, ...params) => {
	console.log("get")
	return new Promise((resolve, reject) => {
		axios.get(url, {
				params: params
			})
			.then(res => {
				resolve(res.data);
				console.log("2")
			})
			.catch(err => {
				reject(err.data)
			})
	});
}
    /**
     * post方法，对应post请求
     * @param {String} url [请求的url地址]
     * @param {Object} params [请求时携带的参数]
     */
export const post = (url, ...params) => {
	console.log("post")
	
    return new Promise((resolve, reject) => {
        axios.post(url, qs.stringify(...params))
            .then(res => {
				console.log("1")
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
};


export default axios



// WEBPACK FOOTER //
// ./src/common/axios.js